"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CloseIcon = _interopRequireDefault(require("../Icons/CloseIcon"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _Separator = _interopRequireDefault(require("../Separator/Separator"));

var _Title = _interopRequireDefault(require("../Typography/Title"));

var _VerticalSeparator = _interopRequireDefault(require("../Separator/VerticalSeparator"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Private header component used for modals.
 */
var ModalHeader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ModalHeader, _React$Component);

  function ModalHeader() {
    _classCallCheck(this, ModalHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(ModalHeader).apply(this, arguments));
  }

  _createClass(ModalHeader, [{
    key: "getActionsContainer",

    /**
     * Get Header Actions Container
     * @param {node} headerActions - actions for header
     * @param {function} onClose - On close callback
     * @param {object} closeIconProps - Props for close icon
     * @returns {node} for header actions
     */
    value: function getActionsContainer(headerActions, onClose, closeIconProps) {
      var actions;

      if (headerActions) {
        actions = _react.default.createElement(_Separator.default, {
          separator: _react.default.createElement(_VerticalSeparator.default, null)
        }, headerActions);
      } else {
        actions = _react.default.createElement(_CloseIcon.default, _extends({
          onClick: onClose
        }, closeIconProps));
      }

      return _react.default.createElement(_FlexLayout.default, {
        alignItems: "center",
        className: "actions-container"
      }, actions);
    }
    /**
     * Renders title
     * @param {node} title - title for header
     * @returns {node} for title
     */

  }, {
    key: "renderTitle",
    value: function renderTitle(title) {
      if ((0, _isString2.default)(title)) {
        return _react.default.createElement(_Title.default, {
          className: "header-title",
          size: "h3"
        }, title);
      }

      return _react.default.createElement("div", {
        className: "header-title"
      }, title);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          headerActions = _this$props.headerActions,
          size = _this$props.size,
          onClose = _this$props.onClose,
          closeIconProps = _this$props.closeIconProps,
          props = _objectWithoutProperties(_this$props, ["children", "headerActions", "size", "onClose", "closeIconProps"]);

      return _react.default.createElement(_FlexLayout.default, _extends({
        itemSpacing: size === 'large' ? '20px' : '0px',
        alignItems: "center",
        "data-size": size,
        justifyContent: size === 'large' ? 'space-between' : 'center',
        padding: "0px-20px",
        className: "".concat(_ThemeManager.default.getVar('classPrefix'), "-modal-header")
      }, props), this.renderTitle(children), this.getActionsContainer(headerActions, onClose, closeIconProps));
    }
  }]);

  return ModalHeader;
}(_react.default.Component);

exports.default = ModalHeader;
ModalHeader.SIZE = {
  DEFAULT: 'default',
  LARGE: 'large'
};
ModalHeader.defaultProps = {
  size: ModalHeader.SIZE.DEFAULT
};
ModalHeader.propTypes = {
  /**
   * Title goes here.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),

  /**
   * Place primary modal actions here. For example Close and Help icons. Note: Usage of this
   * property will negate the built in onClose prop.
   */
  headerActions: _propTypes.default.node,

  /**
   * The onClose callback will be called when the close (X) action is clicked.
   */
  onClose: _propTypes.default.func,

  /**
   * Size of header.
   */
  size: _propTypes.default.oneOf([ModalHeader.SIZE.DEFAULT, ModalHeader.SIZE.LARGE])
};